import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { api, getUser } from '../services/api'

export default function Support() {
  const user = getUser()
  const [name, setName] = useState(user?.name || '')
  const [email, setEmail] = useState(user?.email || '')
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      await api.post('/support', { name, email, subject, message })
      setSent(true)
    } catch (err: any) {
      setError(err.response?.data?.error || t('support.error'))
    } finally {
      setLoading(false)
    }
  }

  const backPath = user ? '/dashboard' : '/login'

  return (
    <div style={{minHeight:'100vh',backgroundColor:'#f8f9fa',padding:20}}>
      <div style={{maxWidth:500,margin:'0 auto'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 0'}}>
          <button style={{background:'none',border:'none',color:'#2D7A3A',fontSize:17,cursor:'pointer',padding:0}} onClick={() => navigate(backPath)}>
            {t('support.back')}
          </button>
          <div style={{display:'flex',gap:12,alignItems:'center'}}>
            <button style={{background:'none',border:'none',color:'#888',fontSize:14,cursor:'pointer',padding:0}} onClick={() => navigate('/changelog')}>🗞</button>
          </div>
        </div>

        <div style={{backgroundColor:'#fff',borderRadius:20,padding:32,boxShadow:'0 4px 24px rgba(0,0,0,0.06)'}}>
          {sent ? (
            <div style={{textAlign:'center',padding:'20px 0'}}>
              <div style={{fontSize:56,marginBottom:16}}>✉️</div>
              <h2 style={{fontSize:22,fontWeight:600,color:'#1a1a1a',margin:'0 0 8px'}}>{t('support.success.title')}</h2>
              <p style={{fontSize:15,color:'#888',margin:'0 0 32px'}}>
                {t('support.success.subtitle')} <strong>{email}</strong>
              </p>
              <button style={{padding:'12px 32px',borderRadius:12,border:'none',backgroundColor:'#2D7A3A',color:'#fff',fontSize:16,fontWeight:600,cursor:'pointer'}} onClick={() => navigate(backPath)}>
                {t('support.success.back')}
              </button>
            </div>
          ) : (
            <>
              <h1 style={{fontSize:22,fontWeight:600,color:'#1a1a1a',margin:'0 0 6px'}}>{t('support.title')}</h1>
              <p style={{fontSize:14,color:'#888',margin:'0 0 28px'}}>{t('support.subtitle')}</p>

              {error && <div style={{backgroundColor:'#fff0f0',color:'#e74c3c',padding:'12px 16px',borderRadius:10,fontSize:14,marginBottom:16}}>{error}</div>}

              <form onSubmit={handleSubmit} style={{display:'flex',flexDirection:'column',gap:12}}>
                <input
                  style={{padding:'14px 16px',borderRadius:12,border:'1px solid #e0e0e0',fontSize:15,outline:'none'}}
                  type="text"
                  placeholder={t('support.name')}
                  value={name}
                  onChange={e => setName(e.target.value)}
                  required
                />
                <input
                  style={{padding:'14px 16px',borderRadius:12,border:'1px solid #e0e0e0',fontSize:15,outline:'none'}}
                  type="email"
                  placeholder={t('support.email')}
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
                <input
                  style={{padding:'14px 16px',borderRadius:12,border:'1px solid #e0e0e0',fontSize:15,outline:'none'}}
                  type="text"
                  placeholder={t('support.subjectPlaceholder')}
                  value={subject}
                  onChange={e => setSubject(e.target.value)}
                  required
                />
                <textarea
                  style={{padding:'14px 16px',borderRadius:12,border:'1px solid #e0e0e0',fontSize:15,outline:'none',resize:'vertical',minHeight:140,fontFamily:'inherit'}}
                  placeholder={t('support.messagePlaceholder')}
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  required
                />
                <button style={{padding:14,borderRadius:12,border:'none',backgroundColor:'#2D7A3A',color:'#fff',fontSize:16,fontWeight:600,cursor:'pointer',marginTop:4}} type="submit" disabled={loading}>
                  {loading ? t('support.loading') : t('support.submit')}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
